import { FC } from 'react';
import { OrganizationImageBlockOrganism } from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { Label } from '../../atoms';
import cn from 'classnames';
import styles from './OrganizationImageBlockEditTemplate.module.css';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { ImageBlockResponseDto } from '../../../store/buyerAPI/block/dto/response/image-block-response.dto';

export interface OrganizationImageBlockEditTemplateProps {
  handleOnChange: (imageBlock: ImageBlockResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  handleBackgroundOnChange: (imageMeta: ImageMeta) => void;
  imageBlock: ImageBlockResponseDto;
  callbackFn: (imageBlock: ImageBlockResponseDto) => void;
}

const OrganizationImageBlockEditTemplate: FC<
  OrganizationImageBlockEditTemplateProps
> = ({
  handleOnChange,
  handleImageOnChange,
  imageBlock,
  callbackFn,
  handleBackgroundOnChange,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <div className={cn(styles.labelWrapper)}>
          <Label content="Update Image Block" size="lg" />
        </div>
        <OrganizationImageBlockOrganism
          handleOnChange={handleOnChange}
          handleImageOnChange={handleImageOnChange}
          handleBackgroundOnChange={handleBackgroundOnChange}
          imageBlock={imageBlock}
          callbackFn={callbackFn}
        />
      </Container>
    </BaseTemplate>
  );
};

export default OrganizationImageBlockEditTemplate;
